<template>
  <div v-if="project" id="dashboard">
    <div class="layout__content__header">
      <!--app-alerts /-->
      <h1 class="">
        {{ $t("dashboard") }}
      </h1>
    </div>
    <div v-if="project?.projectId && project?.projectId != 'undefined'" class="layout__content__content">
      <div class="mb-5 row">
        <div class="col-md-6">
          <div class="row">
            <div class="mb-sm-3 mb-md-2 mb-lg-3 col-6">
              <div v-if="project" class="layout__box dashboard__devices">
                <div class="layout__box__header justify-content-between">
                  <div class="d-flex align-items-center">
                    <div class="atom-icon mr-2">
                      <img class="navbar__menu__icon" src="@/assets/icons/headers/ico-zarizeni-gray.svg" />
                    </div>
                    <h2 class="mb-0">
                      {{ $t("zarizeni") }}
                    </h2>
                  </div>

                  <RouterLink
                    :to="{
                      name: 'devices',
                      params: {
                        customerId: customerId,
                        projectId: projectId
                      }
                    }"
                    tag="a"
                  >
                    <img src="@/assets/icons/arrows/arr-double.svg" />
                  </RouterLink>
                </div>
                <div class="layout__box__content">
                  <div v-if="devicesOverview" class="pt-2 pb-4">
                    <div v-if="devicesOverview.active" class="text-extra-large w-100">
                      {{
                        (devicesOverview.active ? devicesOverview.active : 0) +
                        (devicesOverview.other ? devicesOverview.other : 0)
                      }}
                    </div>
                    <div v-else class="text-extra-large w-100">?</div>
                    <div v-if="devicesOverview" class="gray-text text-extra-small dashboard__devices__groups">
                      {{ $t("v") }}
                      <RouterLink
                        :to="{
                          name: 'groups',
                          params: {
                            customerId: customerId,
                            projectId: projectId
                          }
                        }"
                        class="link-gray"
                      >
                        <span v-if="devicesOverview.groups">
                          {{ `${devicesOverview.groups} ` }}
                        </span>
                        <span v-else>0</span>
                        <span v-if="devicesOverview.groups == 1">
                          {{ $t("skupine") }}
                        </span>
                        <span v-else-if="devicesOverview.groups > 1">
                          {{ $t("skupinach") }}
                        </span>
                        <span v-else>{{ $t("skupinach") }}</span>
                      </RouterLink>
                    </div>
                    <span v-else class="gray-text text-extra-small">
                      <Loader />
                    </span>
                  </div>
                </div>
                <div class="layout__box__content">
                  <div class="pt-2 pb-3">
                    <div class="dashboard__devices__row d-flex align-items-center justify-content-between">
                      <!--
                      <router-link
                        :to="{
                          name: 'lora',
                          params: {
                            customerId: customerId,
                            projectId: projectId
                          }
                        }"
                        class="link-gray"
                        >
                        -->
                      <span>{{ $t("rezimAktivni") }}</span>
                      <!--</router-link
                      >-->
                      <span v-if="devicesOverview && devicesOverview.active >= 0" class="font-weight-bold">
                        {{
                          (devicesOverview.active ? devicesOverview.active : 0) -
                          (devicesOverview.suspended ? devicesOverview.suspended : 0)
                        }}
                      </span>
                      <span v-else-if="deviceOveviewLoading" class="gray-text text-extra-small">?</span>
                      <span v-else class="font-weight-bold">0</span>
                    </div>
                    <div class="dashboard__devices__row d-flex align-items-center justify-content-between">
                      <!--
                      <router-link
                        :to="{
                          name: 'lora',
                          params: {
                            customerId: customerId,
                            projectId: projectId
                          }
                        }"
                        class="link-gray"
                        >
                        -->
                      <span>{{ $t("rezimPresLimit") }}</span>
                      <!--
                        </router-link
                      >-->
                      <span v-if="devicesOverview?.suspended >= 0" class="font-weight-bold">
                        <div
                          :class="{
                            'atom-counter--danger': devicesOverview.suspended > 0,
                            'atom-counter--success': devicesOverview.suspended == 0
                          }"
                          class="atom-counter mr-0"
                        >
                          {{ devicesOverview.suspended }}
                        </div>
                      </span>
                      <span v-else-if="deviceOveviewLoading" class="gray-text text-extra-small">?</span>
                      <span v-else class="font-weight-bold">0</span>
                    </div>
                    <div class="dashboard__devices__row d-flex align-items-center justify-content-between">
                      <!--
                      <router-link
                        :to="{
                          name: 'lora',
                          params: {
                            customerId: customerId,
                            projectId: projectId
                          }
                        }"
                        class="link-gray"
                        >
                        -->
                      <span>{{ $t("dalsiLimity") }}</span>
                      <!--</router-link
                      >-->
                      <span v-if="devicesOverview?.other >= 0" class="font-weight-bold">
                        {{ devicesOverview.other }}
                      </span>
                      <span v-else-if="deviceOveviewLoading" class="gray-text text-extra-small">?</span>
                      <span v-else class="font-weight-bold">0</span>
                    </div>
                    <RouterLink
                      :to="{
                        name: 'import',
                        params: {
                          customerId: customerId,
                          projectId: projectId
                        }
                      }"
                      class="btn btn-primary w-100 d-flex align-items-center justify-content-center"
                    >
                      <div class="atom-icon">
                        <img src="@/assets/icons/actions/ico-btn-nova.svg" />
                      </div>
                      {{ $t("importZarizeni") }}
                    </RouterLink>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-sm-3 mb-md-2 mb-lg-3 col-6">
              <div v-if="project" class="layout__box dashboard__devices">
                <div class="layout__box__header justify-content-between">
                  <div class="d-flex align-items-center">
                    <div class="atom-icon mr-2">
                      <img class="navbar__menu__icon" src="@/assets/icons/menu/ico-menu-endpointy-gray.svg" />
                    </div>
                    <h2 class="mb-0">
                      {{ $t("routovaciSkupiny") }}
                    </h2>
                  </div>

                  <RouterLink
                    :to="{
                      name: 'groups',
                      params: {
                        customerId: customerId,
                        projectId: projectId
                      }
                    }"
                    tag="a"
                  >
                    <img src="@/assets/icons/arrows/arr-double.svg" />
                  </RouterLink>
                </div>
                <div class="layout__box__content dashboard__devices__count">
                  <div class="pt-2 pb-3">
                    <span v-if="groupsOverview" class="text-extra-large">
                      {{ groupsOverview.groupsCount }}
                    </span>

                    <span class="gray-text text-extra-small" />
                  </div>
                </div>
                <div class="layout__box__content">
                  <div class="pt-2 pb-3">
                    <div class="dashboard__devices__row d-flex align-items-center justify-content-between">
                      <!--
                      <router-link
                        :to="{
                          name: 'endpoints',
                          params: {
                            customerId: customerId,
                            projectId: projectId
                          }
                        }"
                        class="link-gray"
                        >
                        -->
                      <span>
                        {{ $t("LABEL_NEVYUZITE") }}
                        <InfoExclamationMark :info-tooltip="'TOOLTIP_DASHBOARD_GROUPS_UNUSED_DEVICES'" />
                      </span>
                      <!--
                        </router-link
                      >-->
                      <span class="font-weight-bold">
                        <div>{{ groupsOverview.groupsWithoutDevices }}</div>
                      </span>
                    </div>
                    <div class="dashboard__devices__row d-flex align-items-center justify-content-between">
                      <!--
                      <router-link
                        :to="{
                          name: 'endpoints',
                          params: {
                            customerId: customerId,
                            projectId: projectId
                          }
                        }"
                        class="link-gray"
                        >
                        -->
                      <span>
                        {{ $t("LABEL_BEZ_VYSTUPU") }}
                        <InfoExclamationMark :info-tooltip="'TOOLTIP_DASHBOARD_GROUPS_UNUSED_ENDPOINTS'" />
                      </span>

                      <!--
                        </router-link
                      >-->
                      <span class="font-weight-bold">
                        {{ groupsOverview.groupsWithoutEndpoints }}
                      </span>
                    </div>
                    <RouterLink
                      :to="{
                        name: 'dataFlowNew',
                        params: {
                          customerId: customerId,
                          projectId: projectId
                        }
                      }"
                      class="btn btn-primary w-100 d-flex align-items-center justify-content-center"
                    >
                      <div class="atom-icon">
                        <img src="@/assets/icons/actions/ico-btn-nova.svg" />
                      </div>
                      {{ $t("novaRoutovaciSkupina") }}
                    </RouterLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mb-md-2 mb-lg-3 col-md-6">
          <div class="layout__box dashboard__limits">
            <div class="layout__box__header justify-content-between">
              <div class="d-flex align-items-center">
                <div class="atom-icon mr-2">
                  <img class="navbar__menu__icon" src="@/assets/icons/headers/ico-limity-sluzeb.svg" />
                </div>
                <h2 class="mb-0">
                  {{ $t("limitySluzeb") }}
                </h2>
              </div>

              <RouterLink
                v-if="apiUser && apiUser.isCustomerAdmin"
                :to="{
                  name: 'adminCustomerServicesLimits',
                  params: { projectId: projectId, customerId: customerId }
                }"
              >
                <img src="@/assets/icons/arrows/arr-double.svg" />
              </RouterLink>

              <RouterLink
                v-else
                :to="{
                  name: 'adminProjectServicesLimits',
                  params: { projectId: projectId, customerId: customerId }
                }"
              >
                <img src="@/assets/icons/arrows/arr-double.svg" />
              </RouterLink>
            </div>
            <div class="layout__box__content">
              <div v-if="services.length >= 1" class="dashboard__limits__wrapper">
                <div v-if="services" class="mb-2">
                  <span v-if="services.length">
                    {{ `${services.length} ` }}
                  </span>
                  <span v-else-if="servicesOveviewLoading">?</span>
                  <span v-if="services.length == 1">{{ $t("sluzba") }}</span>
                  <span v-else-if="services.length > 1 && services.length < 5">
                    {{ $t("sluzby") }}
                  </span>
                  <span v-else>{{ $t("sluzeb") }}</span>
                </div>
                <div v-if="services.length" v-click-outside="closeOpenedSelect" class="custom-control__select">
                  <div
                    :class="{ opened: openedSelect }"
                    class="custom-control__select__selected"
                    @click="toggleOpenedSelect()"
                  >
                    <span v-if="selectedService">
                      {{ selectedService.tarifName }}
                      <br />
                      <span class="text-smallest">
                        {{ selectedService.custServiceId }}
                      </span>
                    </span>
                  </div>
                  <div v-if="services.length" :class="{ opened: openedSelect }" class="custom-control__select__options">
                    <div
                      v-for="service in services"
                      :key="service.custServiceId"
                      class="custom-control__select__option d-flex align-items-center"
                      @click="selectService(service)"
                    >
                      <div class="check">
                        <img v-if="service === selectedService" class="" src="@/assets/icons/check.svg" />
                      </div>
                      <span class="font-weight-light">
                        {{ service.tarifName }}
                        <br />
                        <span class="text-smallest">
                          {{ service.custServiceId }}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>

                <ServiceLimits v-if="selectedService" :service="selectedService" />
                <!--div v-else class="atom-result">
                  <div
                    class="atom-result__row d-flex align-items-center justify-content-between"
                  >
                    <span class="font-weight-bolder">{{
                      $t("dataNejsouKDispozici")
                    }}</span>
                  </div>
                  <div class="atom-result__footer text-right">
                    <router-link
                      :to="{
                        name: 'service',
                        params: {
                          id: selectedService.custServiceId,
                          service: selectedService
                        }
                      }"
                      v-if="selectedService.custServiceId"
                      >{{ $t("naDetailSluzby") }}</router-link
                    >
                  </div>
                </div-->
              </div>
              <div v-else>
                {{ $t("Žádná aktivní služba k dispozici.") }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-md-2 mt-lg-3 row">
        <div class="col-md-6">
          <h2 class="mb-3">
            {{ $t("posledniAktivniZarizeni") }}
          </h2>
          <div class="dashboard__active">
            <div class="dashboard__active__tabs d-flex align-items-center">
              <div
                :class="{ active: activeSelected === 'lora' }"
                class="dashboard__active__tab"
                @click="changeActiveSelected('lora')"
              >
                {{ $t("DASHBOARD_TAB_LORA") }}
              </div>
              <div
                :class="{ active: activeSelected === 'mqtt' }"
                class="dashboard__active__tab"
                @click="changeActiveSelected('mqtt')"
              >
                {{ $t("DASHBOARD_TAB_MQTT") }}
              </div>
              <div
                :class="{ active: activeSelected === 'udp' }"
                class="dashboard__active__tab"
                @click="changeActiveSelected('udp')"
              >
                {{ $t("DASHBOARD_TAB_UDP") }}
              </div>
            </div>
            <div class="dashboard__active__table">
              <div
                v-if="
                  (loraDevices.length > 0 && activeSelected === 'lora') ||
                  (mqttDevices.length > 0 && activeSelected === 'mqtt') ||
                  (udpDevices.length > 0 && activeSelected === 'udp')
                "
                class="dashboard__active__table__header d-flex"
              >
                <div class="name">
                  <span class="gray-text text-small">
                    {{ $t("nazev") }}
                  </span>
                </div>
                <div class="type">
                  <span class="gray-text text-small">
                    {{ $t("typ") }}
                  </span>
                </div>
                <div class="message">
                  <span class="gray-text text-small">
                    {{ $t("posledniZprava") }}
                  </span>
                </div>
              </div>
              <div v-if="activeSelected === 'lora'" class="dashboard__active__table__content">
                <div v-if="loraDevices.length > 0">
                  <div v-for="lora in loraDevices" :key="lora.deviceId" class="dashboard__active__table__row d-flex">
                    <div class="name column">
                      <RouterLink
                        v-if="lora.custDeviceName"
                        :to="{
                          name: 'device',
                          params: { id: lora.deviceId, device: lora }
                        }"
                        class="font-weight-bolder link-gray"
                      >
                        <span>
                          {{ $filters.strLimit(lora.custDeviceName, 12) }}
                        </span>
                      </RouterLink>
                      <span v-else class="gray-text text-extra-small">
                        <AppLoader />
                      </span>
                    </div>
                    <div class="type column">
                      <span class="font-weight-light">{{ $t("lora") }}</span>
                    </div>
                    <div class="message column">
                      <a
                        v-if="lora.lastMessageIn"
                        class=""
                        @click="
                          () => {
                            toggleShowMessage('showMessage')
                            setMessageDeviceToShow(lora)
                          }
                        "
                      >
                        {{ $t("pred") }}
                        {{ $filters.beforeTime(lora.lastMessageIn, "short") }}
                      </a>
                    </div>
                    <div
                      id="kebab"
                      ref="kebab"
                      :class="{
                        opened: openedDevice.deviceId == lora.deviceId
                      }"
                      class="dashboard__active__table__kebab d-flex align-items-center justify-content-center"
                    >
                      <div class="dropdown-actions">
                        <div class="atom-icon mr-0" @click="openKebab(lora)">
                          <img src="@/assets/icons/menu/ico-kebab.svg" />
                        </div>

                        <div
                          v-if="openedDevice.deviceId == lora.deviceId"
                          v-click-outside="closeKebabConf"
                          class="dropdown-actions__wrapper"
                        >
                          <div class="dropdown-actions__inner">
                            <div
                              class="dropdown-actions__item d-flex align-items-center"
                              @click="
                                () => {
                                  actionItems = [openedDevice]
                                  toggleEditDeviceModal('editDevice')
                                }
                              "
                            >
                              <div class="atom-icon">
                                <img src="@/assets/icons/actions/ico-ico-upravitzarizeni.svg" />
                              </div>
                              {{ $t("upravitZarizeni") }}
                            </div>
                            <div
                              class="dropdown-actions__item d-flex align-items-center"
                              cols="6"
                              @click="
                                () => {
                                  actionItems = [openedDevice]
                                  toggleChangeServiceModal('changeService')
                                }
                              "
                            >
                              <div class="atom-icon">
                                <img src="@/assets/icons/actions/ico-ico-zmenitsluzbu.svg" />
                              </div>
                              {{ $t("zmenitSluzbu") }}
                            </div>
                            <div
                              v-if="openedDevice.partnerId === 3"
                              class="dropdown-actions__item d-flex align-items-center"
                              cols="6"
                              @click="
                                () => {
                                  actionItems = [openedDevice]
                                  toggleSendMessageModal('sendMessage')
                                }
                              "
                            >
                              <div class="atom-icon">
                                <img src="@/assets/icons/actions/ico-ico-zprava.svg" />
                              </div>
                              {{ $t("poslatZpravuNaZarizeni") }}
                            </div>
                            <div
                              class="dropdown-actions__item d-flex align-items-center"
                              cols="6"
                              @click="
                                () => {
                                  actionItems = [openedDevice]
                                  toggleDeleteDevice([openedDevice])
                                }
                              "
                            >
                              <div class="atom-icon">
                                <img src="@/assets/icons/actions/ico-ico-delete-l.svg" />
                              </div>
                              {{ $t("odstranitZarizeni") }}
                            </div>
                            <!--div cols="6" class="dropdown-actions__item d-flex align-items-center">
                                       <div class="atom-icon">
                                         <img src="@/assets/icons/actions/ico-ico-zprava.svg">
                                       </div>
                                       {{ $t("exportZprav") }}
                                   </div-->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="!loraLoading && loraDevices.length == 0">
                  {{ $t("nicKZobrazeni") }}
                </div>
                <div v-if="loraLoading">
                  <AppLoader />
                </div>
                <p class="layout__box__footer text-right">
                  <RouterLink
                    :to="{
                      name: 'lora',
                      params: {
                        customerId: customerId,
                        projectId: projectId
                      }
                    }"
                  >
                    {{ $t("vsechnaZarizeni") }}
                  </RouterLink>
                </p>
              </div>
              <div v-else-if="activeSelected === 'mqtt'" class="dashboard__active__table__content">
                <div v-if="mqttDevices && mqttDevices.length > 0">
                  <div
                    v-for="mqttDevice in mqttDevices"
                    :key="mqttDevice.deviceId"
                    class="dashboard__active__table__row d-flex"
                  >
                    <div class="name column">
                      <RouterLink
                        v-if="mqttDevice.custDeviceName"
                        :to="{
                          name: 'mqttDevice',
                          params: {
                            id: mqttDevice.deviceId,
                            device: mqttDevice,
                            customerId: customerId,
                            projectId: projectId
                          }
                        }"
                        class="font-weight-bolder link-gray"
                      >
                        <span>
                          {{ $filters.strLimit(mqttDevice.custDeviceName, 12) }}
                        </span>
                      </RouterLink>
                      <span v-else class="gray-text text-extra-small">
                        <AppLoader />
                      </span>
                    </div>
                    <div class="type column">
                      <span class="font-weight-light">{{ $t("mqtt") }}</span>
                    </div>
                    <div class="message column">
                      <span v-if="mqttDevice.lastMessageIn">
                        {{ $t("pred") }}
                        {{ $filters.beforeTime(mqttDevice.lastMessageIn, "short") }}
                      </span>
                    </div>
                    <div
                      id="kebab"
                      ref="kebab"
                      :class="{
                        opened: openedDevice.deviceId == mqttDevice.deviceId
                      }"
                      class="dashboard__active__table__kebab d-flex align-items-center justify-content-center"
                    >
                      <div class="dropdown-actions">
                        <div class="atom-icon mr-0" @click="openKebab(mqttDevice)">
                          <img src="@/assets/icons/menu/ico-kebab.svg" />
                        </div>

                        <div
                          v-if="openedDevice.deviceId == mqttDevice.deviceId"
                          v-click-outside="closeKebabConf"
                          class="dropdown-actions__wrapper"
                        >
                          <div class="dropdown-actions__inner">
                            <div class="dropdown-actions__item d-flex align-items-center">
                              <RouterLink
                                :to="{
                                  name: 'mqttDevice',
                                  params: {
                                    id: mqttDevice.deviceId,
                                    device: mqttDevice,
                                    customerId: customerId,
                                    projectId: projectId
                                  }
                                }"
                              >
                                {{ $t("detailZarizeni") }}
                              </RouterLink>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="!mqttLoading && mqttDevices.length == 0">
                  {{ $t("nicKZobrazeni") }}
                </div>
                <div v-if="mqttLoading">
                  <AppLoader />
                </div>

                <p class="layout__box__footer text-right">
                  <RouterLink
                    :to="{
                      name: 'mqttDevices',
                      params: {
                        customerId: customerId,
                        projectId: projectId
                      }
                    }"
                  >
                    {{ $t("vsechnaZarizeni") }}
                  </RouterLink>
                </p>
              </div>
              <div v-else-if="activeSelected === 'udp'" class="dashboard__active__table__content">
                <div v-if="udpDevices.length > 0">
                  <div v-for="device in udpDevices" :key="device.deviceId" class="dashboard__active__table__row d-flex">
                    <div class="name column">
                      <RouterLink
                        v-if="device.name"
                        :to="{
                          name: 'udpDevice',
                          params: {
                            id: device.deviceId,
                            device: device,
                            customerId: customerId,
                            projectId: projectId
                          }
                        }"
                        class="font-weight-bolder link-gray"
                      >
                        <span>
                          {{ $filters.strLimit(device.name, 12) }}
                        </span>
                      </RouterLink>
                      <span v-else class="gray-text text-extra-small">
                        <AppLoader />
                      </span>
                    </div>
                    <div class="type column">
                      <span class="font-weight-light">{{ $t("udp") }}</span>
                    </div>
                    <div class="message column">
                      <span v-if="device.lastMessageIn">
                        {{ $t("pred") }}
                        {{ $filters.beforeTime(device.lastMessageIn, "short") }}
                      </span>
                    </div>
                    <div
                      id="kebab"
                      ref="kebab"
                      :class="{
                        opened: openedDevice.deviceId == device.deviceId
                      }"
                      class="dashboard__active__table__kebab d-flex align-items-center justify-content-center"
                    >
                      <div class="dropdown-actions">
                        <div class="atom-icon mr-0" @click="openKebab(device)">
                          <img src="@/assets/icons/menu/ico-kebab.svg" />
                        </div>

                        <div
                          v-if="openedDevice.deviceId == device.deviceId"
                          v-click-outside="closeKebabConf"
                          class="dropdown-actions__wrapper"
                        >
                          <div class="dropdown-actions__inner">
                            <div class="dropdown-actions__item d-flex align-items-center">
                              <RouterLink
                                :to="{
                                  name: 'udpDevice',
                                  params: {
                                    id: device.deviceId,
                                    device: device,
                                    customerId: customerId,
                                    projectId: projectId
                                  }
                                }"
                              >
                                {{ $t("detailZarizeni") }}
                              </RouterLink>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="!udpLoading && !udpDevices.length">
                  {{ $t("nicKZobrazeni") }}
                </div>
                <div v-if="udpLoading">
                  <AppLoader />
                </div>

                <p class="layout__box__footer text-right">
                  <RouterLink
                    :to="{
                      name: 'udpDevices',
                      params: {
                        customerId: customerId,
                        projectId: projectId
                      }
                    }"
                  >
                    {{ $t("vsechnaZarizeni") }}
                  </RouterLink>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-3 mt-md-0 col-md-6">
          <div class="layout__box news dashboard__news">
            <div class="layout__box__header">
              <div class="atom-icon mr-2">
                <img class="navbar__menu__icon" src="@/assets/icons/headers/ico-novinky-gray.svg" />
              </div>
              <h2 class="mb-0">
                {{ $t("novinkyVIot") }}
              </h2>
            </div>
            <div class="layout__box__content">
              <NewsList :items="sortedArticles" :loading="loadingNews" />
            </div>
          </div>
          <p class="layout__box__footer text-right">
            <RouterLink
              :to="{
                name: 'articles',
                params: {
                  customerId: customerId,
                  projectId: projectId
                }
              }"
            >
              {{ $t("starsiNovinky") }}
            </RouterLink>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <RadioInfo />
        </div>
      </div>
    </div>
    <div v-else class="layout__content__content">
      <div v-if="!project?.projectId || project?.projectId == 'undefined'" />
      <div v-else>
        {{ $t("nicKZobrazeni") }}
      </div>
    </div>
    <ShowMessage
      :device="deviceToShow"
      :item="messageToShow"
      :opened="openedMessageDetail"
      @close-box="toggleShowMessage"
    />

    <DeleteDeviceModal
      :centered="true"
      :items="actionItems"
      :opened="openedDeleteDevice"
      :text="deleteText"
      @close="toggleDeleteDevice()"
      @yes="
        () => {
          deleteDevice()
          toggleDeleteDevice()
        }
      "
    />
    <SendMessageModal
      :devices="actionItems"
      :opened="openedSendMessage"
      @close-box="toggleSendMessageModal"
      @open-box="toggleSendMessageModal"
    />
    <ChangeServiceModal
      :device="actionItems[0]"
      :opened="openedChangeServiceModal"
      @close-box="toggleChangeServiceModal"
      @open-box="toggleChangeServiceModal"
    />
    <EditDeviceModal
      v-if="openedEditDevice.length > 0"
      :device="actionItems[0]"
      :opened="openedEditDevice"
      :tags="tags"
      @close-box="toggleEditDeviceModal"
      @open-box="toggleEditDeviceModal"
      @update-items="updateDevices"
    />
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="openedError = false" />
    </div>
  </div>
</template>

<script>
import axios from "axios"
import _ from "lodash"
import NewsList from "@/components/news/news-list.vue"
import Loader from "@/components/loader.vue"
import RadioInfo from "@/components/radio/radio-info.vue"
import ShowMessage from "@/components/modals/devices/messageShow.vue"

import DeleteDeviceModal from "@/components/confirmations/delete.vue"
import SendMessageModal from "@/components/modals/devices/sendMessage.vue"
import EditDeviceModal from "@/components/modals/devices/edit.vue"
import ChangeServiceModal from "@/components/modals/devices/changeService.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import ServiceLimits from "@/components/boxes/serviceLimits.vue"
import InfoExclamationMark from "@/components/info/infoExclamationMarkNoText.vue"
import { useProjectStore } from "@/store/modules/project"
import { useAuthStore } from "@/store/modules/auth"
import { useConfigStore } from "@/store/modules/config"
import { useLoraStore } from "@/store/modules/devices/lora"
import { useMqttStore } from "@/store/modules/devices/mqtt"
import { useUdpStore } from "@/store/modules/devices/udp"
import { useGroupsStore } from "@/store/modules/groups"
import { useEndpointsStore } from "@/store/modules/endpoints"

export default {
  directives: {},
  components: {
    NewsList,
    Loader,
    RadioInfo,
    ShowMessage,
    DeleteDeviceModal,
    EditDeviceModal,
    ChangeServiceModal,
    SendMessageModal,
    ErrorModal,
    ServiceLimits,
    InfoExclamationMark
  },
  props: {},
  setup() {
    const projectStore = useProjectStore()
    const authStore = useAuthStore()
    const configStore = useConfigStore()
    const loraStore = useLoraStore()
    const mqttStore = useMqttStore()
    const udpStore = useUdpStore()
    const groupsStore = useGroupsStore()

    const endpointsStore = useEndpointsStore()

    return { projectStore, authStore, configStore, loraStore, mqttStore, udpStore, groupsStore, endpointsStore }
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      customerId: this.$route.params.customerId,
      items: [],
      loadingNews: false,
      activeSelected: "lora",
      openedSelect: false,
      openedDevice: {},
      title: "",
      text: "",
      editedItem: null,
      editedItemUrl: "",
      messageToShow: {},
      deviceToShow: {},
      openedMessageDetail: [],
      newItem: [
        {
          title: "",
          text: ""
        }
      ],
      openedDeleteDevice: false,
      openedSendMessage: [],
      openedChangeServiceModal: [],
      openedEditDevice: [],
      deleteText: "",
      tags: [],
      errorsToTranslate: [],
      openedError: false,
      loraLoading: false,
      mqttLoading: false,
      udpLoading: false,
      deviceOveviewLoading: false,
      groupsOverviewLoading: false,
      servicesOveviewLoading: false,
      mqttGatewaysLoading: false,
      closeKebabConf: {
        handler: this.closeKebab,
        middleware: this.middlewareKebab,
        events: ["dblclick", "click"],
        isActive: true,
        detectIFrame: true,
        capture: false
      },
      actionItems: []
    }
  },
  computed: {
    filteredItems() {
      return this.parsedItems.filter((item) => {
        return item.title.indexOf(this.filterBy.toLowerCase()) > -1
      })
    },
    sortedArticles() {
      return _.orderBy(this.items, "datum", "desc").slice(0, 3)
    },
    locale() {
      return this.$i18n.locale
    },
    project() {
      return this.projectStore.selectedProject
    },
    devicesOverview() {
      return this.loraStore.devicesOverview
    },
    loraDevices() {
      return this.loraStore.deviceList
    },
    mqttDevices() {
      return this.mqttStore.deviceList
    },
    udpDevices() {
      return this.udpStore.deviceList
    },
    groupsOverview() {
      return this.groupsStore
    },
    endpointsCount() {
      return this.endpointsStore.allEndpointsCount
    },
    services() {
      /**
       * we must use only service which is not suspended or discontinued
       */
      let storedServices = this.$store.getters["services/services"]
      let services = []
      for (let i = 0; i < storedServices.length; i++) {
        if (storedServices[i].suspended == false && storedServices[i].discontinued == false) {
          services.push(storedServices[i])
        }
      }
      return services
    },
    selectedService() {
      return this.$store.getters["services/service"]
    },
    serviceCounter() {
      return this.$store.getters["services/serviceCounter"]
    },
    apiUser() {
      return this.authStore.apiUser
    }
  },
  watch: {
    locale() {
      this.reloadPosts()
    },
    project() {
      // Skip fetches when there is no selected project. Without this guard the
      // watcher fires on null transitions (e.g. customer switch to a customer
      // with no projects) and child fetchers build malformed URLs / crash on
      // selectedProject.projectId derefs.
      if (!this.project?.projectId) {
        return
      }
      this.getDevicesOverview()
      this.getLora()
      this.getMqtt()
      this.getUdp()
      this.getMqttGateways()
      this.getGroupsOverview()
      this.getServices()
      this.reloadPosts()
      this.getSimcards()
      if (!localStorage.getItem("showTutorialLater") && this.configStore.shouldShowTutorial) {
        this.configStore.isTutorialVisible = true
      }
      if (!localStorage.getItem("showEventTutorialLater") && this.configStore.shouldShowEventTutorial) {
        this.configStore.isEventTutorialVisible = true
      }
      if (!localStorage.getItem("showTutorialLaterAdmin") && this.configStore.shouldShowTutorialAdmin) {
        this.configStore.isAdminTutorialVisible = true
      }
    },
    selectedService() {
      this.$store.dispatch("services/getServiceCounter")
    },
    loraDevices() {
      this.getAllTags()
    }
  },
  mounted() {
    if (this.project) {
      this.reloadPosts()
      this.getDevicesOverview()
      this.getLora()
      this.getMqtt()
      this.getUdp()
      this.getMqttGateways()
      this.getGroupsOverview()
      this.getServices()
      this.getSimcards()
      if (!localStorage.getItem("showTutorialLater") && this.configStore.shouldShowTutorial) {
        this.configStore.isTutorialVisible = true
      }
      if (!localStorage.getItem("showEventTutorialLater") && this.configStore.shouldShowEventTutorial) {
        this.configStore.isEventTutorialVisible = true
      }
    }
  },
  unmounted() {
    if (!localStorage.getItem("showTutorialLater")) {
      this.configStore.isTutorialVisible = false
    }
    if (!localStorage.getItem("showEventTutorialLater")) {
      this.configStore.isEventTutorialVisible = false
    }
  },
  methods: {
    async getLora() {
      this.loraLoading = true
      let lora = await this.loraStore.getProjectDevices()
      if (lora) {
        this.loraLoading = false
      }
    },
    async getMqtt() {
      this.mqttLoading = true
      const mqtt = await this.mqttStore.getList({
        sort: "lastMessageIn",
        sortType: "desc",
        currentPage: 0,
        rowsPerPage: 8,
        filters: [
          {
            field: "projectId",
            operator: "eq",
            value: this.projectStore.selectedProject.projectId
          }
        ]
      })
      if (mqtt) {
        this.mqttLoading = false
      }
    },
    async getUdp() {
      this.udpLoading = true
      let udp = await this.udpStore.getList({
        filters: [{ field: "projectId", value: this.projectId }],
        sort: "lastMessageIn",
        sortType: "desc",
        currentPage: 0,
        rowsPerPage: 8,
        search: ""
      })
      if (udp) {
        this.udpLoading = false
      }
    },
    async getMqttGateways() {
      this.mqttGatewaysLoading = true
      let gateways = await this.endpointsStore.getMqttGateways({
        rowsPerPage: 1000,
        currentPage: 0
      })
      console.log(gateways, "GAAATEWAYS")
      if (gateways) {
        this.mqttGatewaysLoading = false
      }
    },
    async getDevicesOverview() {
      this.deviceOveviewLoading = true
      let deviceOverview = await this.loraStore.getDevicesOverview()
      if (deviceOverview) {
        this.deviceOveviewLoading = false
      }
    },
    async getGroupsOverview() {
      this.groupsOverviewLoading = true
      let groupsOverview = await this.groupsStore.getGroups()
      if (groupsOverview) {
        this.groupsOverviewLoading = false
      }
    },
    async getServices() {
      this.servicesOveviewLoading = true
      let servicesOveview = await this.$store.dispatch("services/getServices")
      if (servicesOveview) {
        this.servicesOveviewLoading = false
      }
    },
    async getSimcards() {
      this.$store.dispatch("simcards/getAllSimcards")
    },
    reloadPosts() {
      this.items = []
      this.loadingNews = true
      this.errorsToTranslate = []

      axios
        .get(process.env.VUE_APP_APICMS + "/" + this.locale + "/article/dashboard")
        .then((response) => {
          //if (typeof response.data == "object") {
          this.items = response.data
          //} else {
          //  this.items = [];
          //}
          this.loadingNews = false
        })
        .catch((error) => {
          if (error.status) {
            let err = []
            err.errors = []
            err.errors.push({
              message: error.status + " " + error.statusText
            })
            this.errorsToTranslate.push(err)
            if (this.errorsToTranslate.length > 0) {
              this.openedError = true
            }
          }
          this.items = []
        })
    },
    updateDevices(devices) {
      devices.forEach((device) => {
        let objIndex = this.loraDevices.findIndex((obj) => obj.deviceId == device.deviceId)
        this.loraDevices[objIndex] = device
      })
    },
    selectService(service) {
      this.$store.commit(
        "services/setService",
        {
          service: service
        },
        {
          root: true
        }
      )
      this.openedSelect = false
    },
    toggleOpenedSelect() {
      this.openedSelect ? (this.openedSelect = false) : (this.openedSelect = true)
    },
    closeOpenedSelect() {
      if (this.openedSelect) {
        this.openedSelect = false
      }
    },
    changeActiveSelected(type) {
      this.activeSelected = type
    },
    openKebab(device) {
      this.openedDevice = this.openedDevice == device ? {} : device
    },
    deleteItem(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete item.", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Yes",
          cancelTitle: "No",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then((value) => {
          if (value) {
            axios
              .delete(process.env.VUE_APP_APICMS + "/cz/article/dashboard" + id + ".json?print=pretty", {})
              .then(() => {
                this.reloadPost()
              })
              .catch(() => {})
          }
        })
        .catch(() => {})
    },
    editItem(url) {
      this.$bvModal.show("modal-multi-4")
      axios
        .get(process.env.VUE_APP_APICMS + "/cz/article" + url, {})
        .then((response) => {
          this.editedItem = response.data[0]
          this.editedItemUrl = url
        })
        .catch(() => {})
    },
    addItem() {
      axios
        .post(process.env.VUE_APP_APICMS + "/cz/article/dashboard", {
          nadpis: this.newItem.title,
          text: this.newItem.text
        })
        .then(() => {
          this.title = ""
          this.text = ""
          this.newItem = [
            {
              title: "",
              text: ""
            }
          ]
          this.reloadPost()
        })
        .catch(() => {})
    },
    patchItem() {
      axios
        .patch(process.env.VUE_APP_APICMS + "/cz/article" + this.editedItemUrl, {
          title: this.editedItem.nadpis,
          text: this.editedItem.text
        })
        .then(() => {
          this.editedItem = null
          this.reloadPost()
        })
        .catch(() => {})
    },
    toggleShowMessage(box) {
      if (this.openedMessageDetail.indexOf(box) > -1) {
        box == undefined
          ? (this.openedMessageDetail = [])
          : this.openedMessageDetail.splice(this.openedMessageDetail.indexOf(box), 1)
      } else {
        this.openedMessageDetail.push(box)
      }
    },
    setMessageDeviceToShow(device) {
      axios
        .get(
          process.env.VUE_APP_API +
            "/lora/devices/" +
            device.deviceId +
            "/up/messages?from=" +
            device.lastMessageIn +
            "&to=" +
            device.lastMessageIn +
            "&limit=1000",
          {
            headers: {}
          }
        )
        .then((result) => {
          const length = result.data.data.length
          let message = result.data.data[length - 1]
          message.type = "up"
          let gws = message.message.gws
          if (gws != null) {
            let sortedBySnr = _.orderBy(gws, "snr", "desc")
            let largestSnr = sortedBySnr[0].snr
            message.snr = largestSnr
            let sortedByRssi = _.orderBy(gws, "rssi", "desc")
            let largestRssi = sortedByRssi[0].rssi
            message.rssi = largestRssi
          }
          this.messageToShow = message
          this.deviceToShow = device
        })
        .catch(() => {})
    },
    openNewGroup() {
      this.$store.commit("modals/setNewGroupVisible", {
        showNewGroup: true
      })
    },
    toggleEditDeviceModal(box) {
      if (this.openedEditDevice.indexOf(box) > -1) {
        box == undefined
          ? (this.openedEditDevice = [])
          : this.openedEditDevice.splice(this.openedEditDevice.indexOf(box), 1)

        this.selectedRows = []
        this.selectedAll = false
        if (box == undefined || box == "editDevice") {
          this.openedDevice = {}
        }
      } else {
        this.openedEditDevice.push(box)
        if (box == "editDevice") {
          this.reloadEditedDevice = true
          this.isSelectedAllOnPage = false
          setTimeout(() => {
            this.reloadEditedDevice = false
          }, 1500)
        }
      }
    },
    toggleChangeServiceModal(box) {
      if (box == undefined || this.openedChangeServiceModal.indexOf(box) > -1) {
        box == undefined
          ? (this.openedChangeServiceModal = [])
          : this.openedChangeServiceModal.splice(this.openedChangeServiceModal.indexOf(box), 1)
        this.isActionsDropdownVisible = false
      } else {
        this.openedChangeServiceModal.push(box)
      }
    },
    toggleSendMessageModal(box) {
      if (box == undefined || this.openedSendMessage.indexOf(box) > -1) {
        box == undefined
          ? (this.openedSendMessage = [])
          : this.openedSendMessage.splice(this.openedSendMessage.indexOf(box), 1)
        this.isActionsDropdownVisible = false
      } else {
        this.openedSendMessage.push(box)
      }
    },
    toggleDeleteDevice(items) {
      if (this.openedDeleteDevice == true) {
        this.openedDeleteDevice = false
        this.deleteText = ""
      } else {
        if (items) {
          this.deleteText = items.length > 1 ? "zarizeniPocet" : items[0].custDeviceName
        }
        this.openedDeleteDevice = true
      }
    },
    getAllTags() {
      let tags = _(this.sortedItems)
        .flatMap((f) => f.tags)
        .sortedUniq()
        .value()
      this.tags = _.uniq(tags)
    },
    async deleteDevice() {
      this.errorsToTranslate = []
      let device = this.openedDevice
      let id = device.deviceId
      let notifications = []
      this.$store.commit("modals/setWaitingLoader", this.$t("Ukládám data, čekejte prosím..."))
      try {
        await this.loraStore.deleteDevice(device)
        this.$store.commit("modals/setWaitingLoader", "")
        this.getLora()
        notifications.push({
          text: "notificationDeviceDelete",
          error: false,
          params: {
            deviceId: id,
            custDeviceName: device.custDeviceName
          }
        })
        this.$store.commit("modals/setGlobalNotification", notifications)
      } catch (e) {
        const er = [{ errors: [] }]
        let message = e.data.errors[0]
        er[0].errors.push({
          message: message,
          attribute: {
            deviceId: device.deviceId,
            custDeviceName: device.custDeviceName
          }
        })
        this.errorsToTranslate = er
        this.openedError = true
        this.$store.commit("modals/setWaitingLoader", "")
      }
    },
    closeKebab() {
      this.openedDevice = {}
    },
    middleware(event) {
      return event.target.className !== "kebab" || event.target.className !== "side-box__inner"
    }
  }
}
</script>

<style scoped></style>
